export type VenueBranch = {
  id: string;
  name: string;
  hasUniversalLogin: boolean;
  email: string;
  password: string;
  verificationCode: string;
  confirmPassword: string;
};
export type VenueSetupData = {
  venue: {
    id: string;
    name: string;
  };
  venueBranches: Array<VenueBranch>;
};

export type VenueStep = 1 | 2 | 3;

export const STEPS = {
  VENUE_DETAILS: 1,
  STAFF_LOGIN: 2,
  REVIEW: 3,
} as const;

export type VenueDetailProps = {
  venueData: VenueSetupData;
  handleChange: (field: keyof VenueSetupData, value: any) => void;
  handleBranchChange: (branchId: string, field: 'name', value: string) => void;
  enableContinueButton: () => void;
};

export type ReviewDetailsProps = {
  venueData: VenueSetupData;
};

export type EmailSent = {
  [branchId: string]: Array<{
    email: string;
    userId: string;
  }>;
};
